<template>
  <div class="pt-[125px] md:pt-[145px] lg:pt-[185px]">
    <div class="container 2xl:max-w-[1320px] mx-auto px-[12px] relative z-[1]">
      <div
        class="flex flex-col items-center text-center mx-auto xl:max-w-[935px] mb-[30px] md:mb-[45px] lg:mb-[60px]"
      >
        <h1
          class="text-center text-[32px] md:text-[40px] lg:text-[50px] xl:text-[60px] mb-[13px] md:mb-[22px] lg:mb-[25px] xl:mb-[30px] -tracking-[.5px] md:-tracking-[1px] xl:-tracking-[1.5px] leading-[1.2] mx-auto w-full"
          style="text-align: center !important;"
        >
          Say Goodbye to Manual Work – Your CRM Now Comes With an AI Team.
        </h1>
        <p
          class="text-center mx-auto leading-[1.6] md:text-[15px] lg:text-[16px] xl:text-[18px] md:max-w-[600px] lg:max-w-[650px] xl:max-w-[740px] xl:tracking-[.2px]"
        >
          Fire the Team. Keep the Results. Your Business Is Now Powered by AI Employees Who Sell, Support, and Scale – 24/7, No Sick Days, No Excuses.
        </p>
      </div>
      <div class="text-center flex justify-center items-center w-full">
        <img
          src="@/assets/images/front-pages/dashboard.png"
          class="mx-auto max-w-full h-auto"
          alt="dashboard-image"
        />
      </div>
      <div
        class="absolute -z-[1] right-[-30px] bottom-[50px] blur-[150px]"
      >
        <img src="@/assets/images/front-pages/shape3.png" alt="shape3" />
      </div>
      <div
        class="absolute -z-[1] left-[25px] -top-[210px] blur-[125px]"
      >
        <img src="@/assets/images/front-pages/shape2.png" alt="shape3" />
      </div>
      <div
        class="absolute -z-[1] right-[260px] -top-[125px] blur-[75px]"
      >
        <img src="@/assets/images/front-pages/shape4.png" alt="shape3" />
      </div>
      <div
        class="absolute -z-[1] left-[-50px] bottom-0 blur-[75px]"
      >
        <img src="@/assets/images/front-pages/shape5.png" alt="shape3" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Banner",
});
</script>
